import { Transforms } from 'slate';

export const VARIABLE = 'variable';

export default function withPaste(editor, copyRef) {
  const { insertData } = editor;

  editor.insertData = data => {
    // If we have copied HTML from the answer panel, it supersedes other content. I'm pretty sure that thanks
    // to the logic in useCopyForNewSlate that clears out the copiedHtml when the 'copy' event is triggered
    // that we should never see both happen at the same time. But who knows
    if (copyRef.current.copiedHtml) {
      const fragment = editor.getSaturatedFragment(copyRef.current.copiedHtml);
      Transforms.insertFragment(editor, fragment);
    } else {
      // HACK: For some reason, pasting plaintext into the editor doesn't seem to do the expected thing of
      // first deleting the fragment that's currently selected before inserting the text. This means that
      // if you have a variable selected, pasting plaintext (e.g. copied text from an input elsewhere
      // in the app) will modify the contents of the variable, rather than replacing them.
      if (data.getData('text/plain')) {
        editor.deleteFragment();
      }

      insertData(data);
    }
  };

  return editor;
}
